
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-gpk/pejabat-penilai-kinerja/perencanaan/disetujui",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-gpk/pejabat-penilai-kinerja/perencanaan/disetujui/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-gpk/pejabat-penilai-kinerja/perencanaan/disetujui"])
      });
    }
  